"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CrossClientChannel = /*#__PURE__*/_createClass(function CrossClientChannel() {
  var _this = this;

  _classCallCheck(this, CrossClientChannel);

  _defineProperty(this, "emit", function (eventName, message) {
    window.localStorage.setItem(eventName, JSON.stringify(message));
    window.localStorage.removeItem(eventName);
  });

  _defineProperty(this, "on", function (eventName, listener) {
    if (_this.registeredListeners.has(eventName)) {
      var existingListener = _this.registeredListeners.get(eventName);

      window.removeEventListener('storage', existingListener);

      _this.LOGGER.debug('Removed storage event listener ' + eventName);
    }

    var newListener = function newListener(_ref) {
      var key = _ref.key,
          newValue = _ref.newValue;

      if (key === eventName && newValue) {
        listener(JSON.parse(newValue));
      }
    };

    window.addEventListener('storage', newListener);

    _this.LOGGER.debug('Registered storage event listener ' + eventName);

    _this.registeredListeners.set(eventName, newListener);
  });

  this.registeredListeners = new Map();
  this.LOGGER = new _amb.default('amb.CrossClientChannel');
});

var _default = CrossClientChannel;
exports.default = _default;